<template>
  <TemplateLayout :navigation="false">
    <template #main>
      <slot />
    </template>
    <template #banner>
      <div id="banner-bottom"></div>
    </template>
    <template #footer></template>
  </TemplateLayout>
</template>
